import { data, Link, useLocation, useNavigate } from 'react-router-dom';
import './login.css';
import { useEffect, useState } from 'react';

export default function OTPVerification() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const [timer, setTimer] = useState(60);
    const [otpUser, setOtpUser] = useState();
    const [inCorrectOtp, setInCorrectOtp] = useState(false);
    const [sendAgainOtp, setSendAgainOtp] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const emailId = location.state?.emailId || '';

    function handleVerification() {

        const dataToSend = {
            userId: emailId,
            otp: otpUser
        }

        try {
            fetch(`${BACKEND_URL}/otp-verification`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type':'application/json',
                },
                body:JSON.stringify(dataToSend)
            }).then((response) => response.json())
                .then((data) => {
                    if (data.success === true) {
                        localStorage.setItem('userId', JSON.stringify(emailId))
                        navigate('/');
                    } else {
                        setInCorrectOtp(true);
                    }
                    setLoading(false)
                }).catch((err) => {
                    alert('Something went wrong')
                    console.log(err)
                })
        } catch (err) {
            alert('something went wrong')
        } finally {
            setLoading(true)
        }
    }

    function handleSendOtpAgain() {
        setTimer(60)
        setSendAgainOtp(false)

        const dataToSend = {
            userId: emailId
        }
        try {
            fetch(`${BACKEND_URL}/login`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type':'application/json',
                },
                body:JSON.stringify(dataToSend)
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data)
                    setLoading(false);
                    navigate('/otp-verification', {state:{emailId}});
                }).catch((error) => {
                    console.log(error)
                    alert('Error Occured!')
                })
        } catch (err){
            alert('something Went Wrong')
        } finally {
            setLoading(true)
        }
        
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    setSendAgainOtp(true);
                    clearInterval(interval);
                    return 0; // Stop at 0
                }
                return prev - 1;
            });
        }, 1000);
    
        return () => clearInterval(interval); // Cleanup on unmount
    }, [sendAgainOtp]);

    const formattedTimer = timer.toString().padStart(2, "0");

    return (
        <div className='login-box'>
            <div style={{display:'flex', justifyContent:'center'}}>
                <img src='ontimeurban-cropped.jpg' alt='logo' className='login-logo'/>
            </div>
            <div className='login-bottom-box'>
                <p className='login-heading' style={{ fontSize: '16px' }}>OTP has been sent to <span style={{ color: '#2c5f2d' }}> { emailId }</span></p>
                <p style={{ marginTop: '0px', color: '#2c5f2d', fontSize:'18px' }}>00:{formattedTimer} sec</p>
                {
                    sendAgainOtp && <p style={{ marginTop: '0px' }}>Didn't get it? <span style={{color:'#2c5f2d'}} onClick={handleSendOtpAgain}>Send OTP</span></p>
                }
                <input
                    type='number'
                    placeholder='Enter OTP'
                    className='phone-input-login'
                    value={otpUser}
                    onChange={(e) => setOtpUser(e.target.value)}
                />
                {
                    inCorrectOtp && <p style={{marginTop:'5px', marginBottom:'5px', color:'red'}}>Incorrect OTP</p>
                }
                {
                    loading ? (
                        <div className='login-otp-btn' style={{display:'flex', justifyContent:'center', alignItems:'center', opacity:'0.7'}}>
                            <div className="spinner"></div>
                        </div>
                    ): (
                        <div className='login-otp-btn' onClick={handleVerification}>
                            Submit
                        </div>
                    )
                }
            </div>
        </div>
    );
}